(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["noelle-promo-banner"] && !Shopify.designMode) return;
  try {
    (()=>{
    const init=(scope=document)=>scope.querySelectorAll('[data-noelle-promo]').forEach(root=>{
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      const group=root.querySelector('.noelle-promo-group');
      const measure=()=>root.style.setProperty('--noelle-promo-duration',`${group.getBoundingClientRect().width/52}s`);
      measure();
      if(document.fonts)document.fonts.ready.then(measure);
      if(window.ResizeObserver)new ResizeObserver(measure).observe(group);
    });
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
    document.addEventListener('shopify:section:load',event=>init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
